import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect, disconnect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import * as s from "./styles/globalStyles";
import styled from "styled-components";





//   import {
//     init,
//     useConnectWallet,
//     useSetChain,
//     useWallets
//   } from '@web3-onboard/react'
//   import injectedModule from '@web3-onboard/injected-wallets';
//   // import coinbaseModule from '@web3-onboard/coinbase';
//   // import gnosisModule from '@web3-onboard/gnosis';
//   // import trezorModule from '@web3-onboard/trezor';
//   // import ledgerModule from '@web3-onboard/ledger';
//   // import walletConnectModule from '@web3-onboard/walletconnect';
  
//   const injected = injectedModule()
//   // const coinbase = coinbaseModule()
//   // const walletConnect = walletConnectModule()
//   // const gnosis = gnosisModule();
//   // const treznor = trezorModule();
//   // const ledger = ledgerModule();
  
// const web3Onboard = init({
//     wallets: [
//       injected,
//       // coinbase,
//       // ledger,
//       // trezor,
//       // gnosis,
//       // treznor,
//       // walletConnect,
//     ],
//     chains: [
//       {
//         id: '0x1',
//         token: 'ETH',
//         label: 'Ethereum Mainnet',
//         rpcUrl: 'https://mainnet.infura.io/v3/ababf9851fd845d0a167825f97eeb12b'
//       },
//       // {
//       //   id: '0x4',
//       //   token: 'rETH',
//       //   label: 'Ethereum Rinkeby Testnet',
//       //   rpcUrl: 'https://rinkeby.infura.io/v3/ababf9851fd845d0a167825f97eeb12b'
//       // },
//     ],
//     appMetadata: {
//       name: 'NGHTMRE DRMVRSE',
//       icon: '<svg><svg/>',
//       description: 'Demo app for Onboard V2',
//       recommendedInjectedWallets: [
//         { name: 'MetaMask', url: 'https://metamask.io' },
//         { name: 'Coinbase', url: 'https://wallet.coinbase.com/' }
//       ]
//     },
//     accountCenter: {
//       desktop: {
//         position: 'topRight',
//         enabled: true,
//         minimal: true
//       },
//       mobile: {
//         position: 'topRight',
//         enabled: true,
//         minimal: true
//       }
//     }
//   })

  


  const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;


export const StyledButton = styled.button`
  padding: 0px;
  border-radius: 0px;
  border: none;
  background-color: var(--secondary);
  font-weight: 700;
  font-size: 14px;
  color: var(--secondary-text);
  width: 100px;
  cursor: pointer;
  line-height: 46px;
  min-width: 144px;
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;


export const StyledInput = styled.input`
  font-size: 18px;
  padding: 8px;
  border-radius: 0px;
`;


// export const StyledRoundButton = styled.button`
//   padding: 10px;
//   border-radius: 100%;
//   border: none;
//   background-color: var(--primary);
//   padding: 10px;
//   font-weight: bold;
//   font-size: 15px;
//   color: var(--primary-text);
//   width: 30px;
//   height: 30px;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
//   -webkit-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
//   -moz-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
//   :active {
//     box-shadow: none;
//     -webkit-box-shadow: none;
//     -moz-box-shadow: none;
//   }
// `;

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  // justify-content: stretched;
  // align-items: stretched;
  width: 100%;
  @media (min-width: 767px) {
    flex-direction: row;
  }
`;

// export const StyledLogo = styled.img`
//   width: 200px;
//   @media (min-width: 767px) {
//     width: 300px;
//   }
//   transition: width 0.5s;
//   transition: height 0.5s;
// `;

// export const StyledImg = styled.img`
//   box-shadow: 0px 5px 11px 2px rgba(255, 29, 236,0.2);
//   border: 4px solid var(--secondary);
//   background-color: var(--accent);
//   border-radius: 100%;
//   width: 200px;
//   @media (min-width: 900px) {
//     width: 250px;
//   }
//   @media (min-width: 1000px) {
//     width: 300px;
//   }
//   transition: width 0.5s;
// `;

export const StyledLink = styled.a`
  color: var(--secondary);
  text-decoration: none;
`;



const MessageCorrectNetwork = (props) => { 
  return ( <s.TextDescription
    style={{
      textAlign: "center",
      color: "var(--primary-text)",
    }}
  >
    Please make sure you are connected to the Ethereum Mainnet network. 
  </s.TextDescription>);
};

// Please note: Once you make the claim, you cannot undo this action.

const MessageSupport = (props) => { 
  return (
    <s.TextDescription
    style={{
      textAlign: "center",
      color: "var(--primary-text)",
    }}
  >
    Minting may take a few minutes to complete. Check your wallet or opensea account to view the NFT. Do not refresh page until after the minting has been confirmed.
  </s.TextDescription>

  );
};

const AlreadyMinted = (props) => {
  return (
    <>
    <s.TextTitle style={{ textAlign: "center", color: "var(--accent-text)" }} >
      Looks like you already minted your NFT.
    </s.TextTitle>
    <s.TextDescription style={{ textAlign: "center", color: "var(--accent-text)" }} >
      You can still find NGHTMRE DRMVRSE on
    </s.TextDescription>
    <s.SpacerSmall />
    <StyledLink target={"_blank"} href={props.CONFIG.MARKETPLACE_LINK}>
      {props.CONFIG.MARKETPLACE}
    </StyledLink>

  </>
  )
};

const StateNotAllowlisted = (props) => { 
  return (<>
    <s.TextDescription
    style={{
      textAlign: "center",
      fontSize: 30,
      color: "var(--warning-text)",
    }}
  >
    Looks like the wallet address {props.account} has not been allowlisted.
  </s.TextDescription>
      <s.SpacerSmall />

      <StyledButton
                      onClick={props.onDisconnect}
                    >
                      DISCONNECT
                    </StyledButton>

      </>
  );
};

const MintNFTButtonBlock = (props) => {
  return (
    <>
    <s.SpacerSmall />
    <MessageSupport></MessageSupport>
    <s.SpacerSmall />

    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      {props.feedback}
                    </s.TextDescription>
                    <s.SpacerMedium />
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>

                      {!props.mintComplete ? 
                      <StyledButton
                        disabled={props.claimingNft ? 1 : 0}
                        onClick={props.onMint}
                      >
                        {props.claimingNft ? "PLEASE WAIT" : "MINT NFT"}
                      </StyledButton>
: <span>Thank You</span>
  }
                    </s.Container>

    </>
  );
}

const MintCompleteBlock = (props) => {
  return (
    <>
    <s.SpacerSmall />

    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      {props.feedback}
                    </s.TextDescription>
                    <s.SpacerMedium />
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>

                    <span>Thank You</span>

                    </s.Container>

    </>
  );
}


const ConnectButtonBlock = (props) => {
  return (
    <>
      <s.TextTitle style={{ textAlign: "center", color: "var(--accent-text)" }}>
        This NFT is free plus gas cost. Use your approved wallet to connect below and mint.  Limit 1 NFT per approved wallet.
      </s.TextTitle>
      <s.SpacerSmall />

      <s.Container ai={"center"} >
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                 
                    </s.TextDescription>
                    
                    <MessageCorrectNetwork name={props.CONFIG.NETWORK.NAME}></MessageCorrectNetwork>
          <s.SpacerSmall />
          {/* <MessageSupport></MessageSupport>
                    <s.SpacerSmall /> */}


                    <StyledButton
                      onClick={props.onConnect}
                    >
                      CONNECT
                    </StyledButton>



                    {props.blockchain && props.blockchain.errorMsg !== "" ? (
                      <>
                        <s.SpacerSmall />
                        <s.TextDescription
                          style={{
                            textAlign: "center",
                            color: "var(--accent-text)",
                          }}
                        >
                          {props.blockchain.errorMsg}
                        </s.TextDescription>
                      </>
                    ) : null}
                  </s.Container>


    </>
  );
}



function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [claimingNft, setClaimingNft] = useState(false);
  const [mintComplete, setMintComplete] = useState(false);


  const [feedback, setFeedback] = useState(``);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
    MINTING_ACTIVE: false
  });

  const claimNFTs = async () => {
    let cost = CONFIG.WEI_COST;
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalCostWei = String(cost);
    let totalGasLimit = String(gasLimit);
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`* MINTING YOUR NGHTMRE NFT - PLEASE WAIT *`);
    setClaimingNft(true);

    // const result = await apiCallValidate( blockchain.account);
    // console.log(result);

    // if(result.status < 0) {
    //   if(result.status === -1) {
    //     setFeedback("This email hasn't been registered for the event.");
    //   } else if(result.status === -2) {
    //     setFeedback("This email was already used to mint an NFT.");
    //   } else if(result.status === -3) {
    //     setFeedback("Only Gallery participants can mint right now. Instructions for virtual visitors will follow via email.");

    //   } else if(result.status === -4) {
    //     setFeedback("You haven't checked in yet (or our systems haven't updated yet");
    //   } else {
    //     setFeedback("Sorry, something went wrong please try again later.");
    //   }
    //   setClaimingNft(false);
    //   return;
    // }

    blockchain.minterSmartContract.methods
      .mint(/* blockchain.validation.proof, */ 1)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
       // value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);

        setFeedback(
          `* Your NGHTMRE Red Rocks NFT has been minted. You can view it in your wallet or on OpenSea.io. *`
        );
        setClaimingNft(false);
        setMintComplete(true);
        dispatch(fetchData(blockchain.account));
      });


  };


  const getData = () => {
    console.log('Get data');
    console.log(blockchain);

    if (blockchain.account && blockchain.minterSmartContract) {
      console.log('dispatching');
      dispatch(fetchData(blockchain.account));
    }
  };

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  if(!CONFIG.MINTING_ACTIVE) {
    return (
      <s.Screen>
        <s.Container
          flex={1}
          ai={"center"}
          style={{ padding: 24, backgroundColor: "#000" }}
    
        >
          <ResponsiveWrapper flex={1} style={{ padding: 24 }} test>
            <h1 style={{fontSize: '32px',opacity: 0.7,lineHeight:"1.3em"}}>Free minting is closed.</h1>
          </ResponsiveWrapper>
          </s.Container>  
          </s.Screen>
    );
  }

  const validationStatus = blockchain && blockchain.validation ? blockchain.validation.status : 99;
  const isNotAllowlisted = validationStatus === -1 || validationStatus === -2;

  // all this should be part of the state handler!!!!

  const showNotAllowlistedBlock = isNotAllowlisted && !mintComplete;
  const showAlreadyMintedBlock = blockchain.connected && Number(data.availableForMint) === 0 && !mintComplete;

  const showMintNFTBlock = (blockchain.connected && 
                            Number(data.availableForMint) > 0 &&
                            !isNotAllowlisted) && !mintComplete;

  const showMintCompleteNFTBlock = mintComplete;

  const showConnectBlock = blockchain.account === "" || blockchain.minterSmartContract === null;


  return (
    <s.Screen>
      <s.Container
//        flex={1}
        ai={"center"}
        style={{ padding: 24, backgroundColor: "#000" }}
      >
        <ResponsiveWrapper flex={1} style={{ padding: 24 }} test>
          <s.Container
            flex={2}
            ai={"center"}
            style={{
              padding: 24,
            }}
          >
            <s.TextTitle
              style={{
                textAlign: "center",
                fontSize: 50,
                fontWeight: "bold",
                lineHeight: '1.0em',
                color: "var(--accent-text)",
              }}
            > FREE INTO THE DRMVRSE RED ROCKS NFT
            </s.TextTitle>

            <s.TextDescription
              style={{
                textAlign: "center",
                color: "var(--primary-text)",
              }}
            >
              {/* <StyledLink target={"_blank"} href={CONFIG.SCAN_LINK}>
                {truncate(CONFIG.CONTRACT_ADDRESS, 15)}
              </StyledLink> */}
            </s.TextDescription>

            <s.SpacerSmall />

            {showNotAllowlistedBlock && <StateNotAllowlisted account={blockchain.account} onDisconnect={ async (e)=> {
                          e.preventDefault();

                          dispatch(disconnect());
                          getData();
  

            }
            } ></StateNotAllowlisted> }

            {showAlreadyMintedBlock && <AlreadyMinted  CONFIG={CONFIG} ></AlreadyMinted>}
            {showMintNFTBlock && <MintNFTButtonBlock feedback={feedback} 
                                                     mintComplete={mintComplete}
                                                     claimingNft={claimingNft}
                                                     onMint={(e) => {
                                                      e.preventDefault();
                                                      claimNFTs();
                                                      getData();
                                                    }}></MintNFTButtonBlock>}

            {showMintCompleteNFTBlock && <MintCompleteBlock feedback={feedback} ></MintCompleteBlock>}


            {showConnectBlock && <ConnectButtonBlock blockchain={blockchain} CONFIG={CONFIG} onConnect={async (e) => {
                        e.preventDefault();

                        dispatch(connect());
                        getData();
                      }}></ConnectButtonBlock>}





            {blockchain.connected && Number(data.availableForMint) === 0 ? (
              // <>
              //   <s.TextTitle
              //     style={{ textAlign: "center", color: "var(--accent-text)" }}
              //   >
              //     Looks like you already minted your NFT.
              //   </s.TextTitle>
              //   <s.TextDescription
              //     style={{ textAlign: "center", color: "var(--accent-text)" }}
              //   >
              //     You can still find NGHTMRE DRMVRSE on
              //   </s.TextDescription>
              //   <s.SpacerSmall />
              //   <StyledLink target={"_blank"} href={CONFIG.MARKETPLACE_LINK}>
              //     {CONFIG.MARKETPLACE}
              //   </StyledLink>
              // </>
              <></>
            ) : (
              <>
                {/* <s.TextTitle
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  This NFT is free plus gas cost. Use your approved wallet to connect below and mint.  Limit 1 NFT per approved wallet.
                </s.TextTitle>
                <s.SpacerSmall /> */}



                {blockchain.account === "" ||
                blockchain.minterSmartContract === null ? (
          //         <s.Container ai={"center"} >
          //           <s.TextDescription
          //             style={{
          //               textAlign: "center",
          //               color: "var(--accent-text)",
          //             }}
          //           >
                 
          //           </s.TextDescription>
                    
          //           <MessageCorrectNetwork name={CONFIG.NETWORK.NAME}></MessageCorrectNetwork>
          // <s.SpacerSmall />
          // <MessageSupport></MessageSupport>

                    
          //           <s.SpacerSmall />


          //           <StyledButton
          //             onClick={async (e) => {
          //               e.preventDefault();

          //               dispatch(connect());
          //               getData();
          //             }}
          //           >
          //             CONNECT
          //           </StyledButton>



          //           {blockchain.errorMsg !== "" ? (
          //             <>
          //               <s.SpacerSmall />
          //               <s.TextDescription
          //                 style={{
          //                   textAlign: "center",
          //                   color: "var(--accent-text)",
          //                 }}
          //               >
          //                 {blockchain.errorMsg}
          //               </s.TextDescription>
          //             </>
          //           ) : null}
          //         </s.Container>
          <></>
                ) : (
                  <>
                    {/* <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      {feedback}
                    </s.TextDescription>
                    <s.SpacerMedium />
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>

                      {!mintComplete ? 
                      <StyledButton
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          claimNFTs();
                          getData();
                        }}
                      >
                        {claimingNft ? "PLEASE WAIT" : "MINT NFT"}
                      </StyledButton>
: <span>Thank You</span>
  }
                    </s.Container> */}
                  </>
                )}
              </>
            )}
            <s.SpacerMedium />
          </s.Container>
        </ResponsiveWrapper>


        <s.SpacerMedium />

        <s.Container jc={"center"} ai={"center"} style={{ width: "70%" }}>
          {/* <MessageCorrectNetwork name={CONFIG.NETWORK.NAME}></MessageCorrectNetwork>
          <s.SpacerSmall />
          <MessageSupport></MessageSupport> */}

        </s.Container>
      </s.Container>
    </s.Screen>
  );
}

export default App;
